import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPaymentHistoryData } from '../services/paymentsApi';

// export const fetchPaymentData = createAsyncThunk(
//   'payment/fetchPaymentData',
//   async () => {
//     try {
//       const paymentData = await getPaymentHistoryData();
//       if (paymentData) {
//         const transformedData = paymentData?.map((item) => ({
//           ...item,
//           organization: item?.organization?.name,
//         }));

//         return transformedData;
//       }
//       return [];
//     } catch (err) {
//       throw err;
//     }
//   },
// );

export const fetchPaymentData = createAsyncThunk(
  'payment/fetchPaymentData',
  async () => {
    const paymentData = await getPaymentHistoryData();
    if (paymentData) {
      return paymentData?.map((item) => ({
        ...item,
        organization: item?.organization?.name,
      }));
    }
    return [];
  },
);

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentData.pending, (state) => ({
        ...state,
        loading: true,
        error: null,
      }))
      .addCase(fetchPaymentData.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        data: action.payload || [],
      }))
      .addCase(fetchPaymentData.rejected, (state, action) => ({
        ...state,
        loading: false,
        error: action.error.message,
      }));
  },
});

export default paymentSlice.reducer;
